import { TimeInput } from "@msuite/ui/date-input";
import { Switch } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import { useFormContext } from "react-hook-form";
import type { BusinessHoursFormValues } from "./business-hours-form-values";
import { WEEKDAY_TRANSLATION_KEYS } from "./weekday-translation-keys";

/** Props Interface */
interface BusinessHoursDayRowProps {
	weekday: number;
	/** The day's position in the `businessHours` array, or null while the day is closed. */
	index: number | null;
	onToggle: (weekday: number, isOpen: boolean) => void;
}

/** One weekday of the editor: open or closed, and from when to when while it is open. */
export function BusinessHoursDayRow({ weekday, index, onToggle }: BusinessHoursDayRowProps) {
	/** Context */
	const { t } = useTranslation();
	const methods = useFormContext<BusinessHoursFormValues>();

	/** Render */
	return (
		<div className="grid grid-cols-[2.5rem_8rem_1fr_1fr] items-center gap-4">
			<Switch
				checked={index !== null}
				onCheckedChange={(isOpen) => onToggle(weekday, isOpen)}
				data-cy={`business-hours-day-${weekday}-switch`}
			/>
			<p className="text-sm">{t(WEEKDAY_TRANSLATION_KEYS[weekday] ?? "--")}</p>
			{index === null ? (
				<p className="label col-span-2">{t("organization.business_hours_closed")}</p>
			) : (
				<>
					<TimeInput
						key={`${weekday}-${index}-starts-at`}
						control={methods.control}
						name={`businessHours.${index}.startsAt`}
						label={null}
					/>
					<TimeInput
						key={`${weekday}-${index}-ends-at`}
						control={methods.control}
						name={`businessHours.${index}.endsAt`}
						label={null}
					/>
				</>
			)}
		</div>
	);
}
